import React, { useState,useEffect,useCallback,useRef } from "react";
import { useParams,useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { getSociaMediaIcons, getTemplateDetail, submitSingle, getSingleDetail, updateSingle, deleteSingle} from "../../../utils/sociaMediaIconsApi";

const IconsTab = ({ isTemplateId,setTemplateId,updateSocialMediaIconsTabData,socialMediaIconsTabData,setRefreshWidgetList }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [apiSociaMediaIcons, setAllSociaMediaIcons] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRefs = useRef([]);
    const [apiProfileSociaMediaIcons, setApiProfileSociaMediaIcons] = useState([]);
    const [isSubmitSingle, setIsSubmitSingle] = useState(false); 
    const location = useLocation();
    const isEditPage = location.pathname.startsWith("/customer/edit/social-media-icons/");
    const { uuid } = useParams();
    const templateId = isEditPage && uuid ? uuid : isTemplateId || "";
    const [apiSingle, setApiSingle] = useState(null);
    const [singleId, setSingleId] = useState(null);

    // Fetch social media icons when "all_icon_list" tab is activated
    useEffect(() => {
        const fetchIcons = async () => {
            setIsLoading(true);
            try {
                const result = await getSociaMediaIcons();
                if (result?.status === true && Array.isArray(result?.data?.data_list)) {
                    setAllSociaMediaIcons(result.data.data_list);
                } else {
                    setAllSociaMediaIcons([]);
                }
            } catch (error) {
                setAllSociaMediaIcons([]);
            } finally {
                setIsLoading(false);
            }
        };

        if (activeSettingElementsTab === "all_icon_list" && apiSociaMediaIcons === null) {
            fetchIcons();
        }
    }, [activeSettingElementsTab, apiSociaMediaIcons]);

    //Wrap fetchTemplateDetails in useCallback to prevent re-creation on every render
    const fetchTemplateDetails = useCallback(async () => {
        if (!templateId) return;

        setIsLoading(true);
        try {
            const templateResult = await getTemplateDetail(templateId);
            if (templateResult?.status === true && Array.isArray(templateResult?.data?.data_list)) {
                if (templateResult?.status === true && templateResult?.data?.data_list) {
                    setApiProfileSociaMediaIcons(templateResult.data.data_list);
                } else {
                    setApiProfileSociaMediaIcons([]);
                }
            } else {
                setApiProfileSociaMediaIcons([]);
            }
        } catch (error) {
            //console.error("Error fetching data:", error);
        } finally {
            setIsLoading(false);
        }
    }, [templateId]);

    // Fix useEffect by including fetchTemplateDetails
    useEffect(() => {
        fetchTemplateDetails();
    }, [fetchTemplateDetails]);

    // Toggle dropdown visibility
    const toggleDropdown = (index) => {
        setOpenDropdown((prev) => (prev === index ? null : index));
    };

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                openDropdown !== null &&
                dropdownRefs.current[openDropdown] &&
                !dropdownRefs.current[openDropdown].contains(event.target) &&
                !event.target.closest(".inner-dropdown-menu")
            ) {
                setOpenDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [openDropdown]);

    //Submit Single Handler
    const handleSubmitSingle = async (iconId) => {
        try {
            // Collect data from refs
            const payload = {
                template_id: templateId,
                icon_id: iconId,
            };

            const response = await submitSingle(payload);
            if (response.status === true) { 
                //Call templat details
                await fetchTemplateDetails();
                setActiveSettingElementsTab("main");
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    };

    // Handle Edit Click 
    const handleEditSingle = (data) => {
        setOpenDropdown(null);
        setSingleId(data.id);
        setActiveSettingElementsTab("edit_single");
        fetchSingleDetails(data.id);
    };

    // Handle Delete Click
    const handleDeleteSingle = async (data) => {
        setOpenDropdown(null);

        try {
            // Prepare the payload
            const payload = {
                single_id: data.id,
            };

            // API Call
            const api_response = await deleteSingle(payload);
            // Check API Response
            if (api_response.status === true) {
                toast.success(api_response.message);

                // Refresh testimonials
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);
            } else {
                toast.error(api_response.message);
            }
        } catch (error) {
            toast.error(`${error.message}`);
        }
    };

    // Wrap fetchSingleDetails in useCallback to prevent re-creation on every render
    const fetchSingleDetails = useCallback(async (singleId) => {
        if (!singleId) return;

        setIsLoading(true); 
        try {
            const templateResult = await getSingleDetail(singleId); 
            if (templateResult?.status === true && templateResult?.data) {
                setApiSingle(templateResult.data);
            } else { 
                setApiSingle(null);
            }
        } catch (error) {
            //console.error("Error fetching number counter:", error);
        } finally {
            setIsLoading(false);
        }
    }, []);

    // Also include fetchTemplateDetails in this useEffect
    useEffect(() => {
        if (isEditPage && uuid && !apiSingle) {
            fetchSingleDetails(uuid);
        }
    }, [isEditPage, uuid, apiSingle, fetchSingleDetails]);

    //Update Single Handler
    const handleUpdateSingle = async (e) => {
        e.preventDefault();

        try {
            setIsSubmitSingle(true);
            setOpenDropdown(null);
            // Create Payload
             const payload = {
                id: singleId,
                icon_url: e.target.icon_url?.value || '',
                icon_lable: e.target.icon_lable?.value || '',
            };

            //Api Call
            const response = await updateSingle(payload);

            if (response.status) {
                toast.success(response.message);

                //Refresh Number Counter
                await fetchTemplateDetails();
                setRefreshWidgetList(prev => !prev);

                // Switch back to the main view
                setActiveSettingElementsTab("main");
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            toast.error(`Error: ${error.message}`);
        } finally {
            setIsSubmitSingle(false);
        }
    }; 

    return (
        <div className="side-baar-layout-tab sidebar_icon_with_list">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Icons</span>
                    <div className="side-baar-box-header ">
                        <div className="box-header-row">
                            {isLoading ? (
                                <div className="inner-loader-container">
                                    <div className="inner-spinner"></div>
                                    <p>Loading, please wait...</p>
                                </div>
                            ) : apiProfileSociaMediaIcons?.length > 0 ? (
                                <ul className="side-baar_texticon-list">
                                    {apiProfileSociaMediaIcons.map((data, index) => (
                                        <li key={index} className="side-baar-item">
                                            <button type="button" className="side-baar-item-button" onClick={() => handleEditSingle(data)}>
                                                <div className="list-image-side-baar">
                                                    <div className="social-icon-list" dangerouslySetInnerHTML={{ __html: data.svg_icon }}></div>
                                                </div>
                                                <div className="list-text-side-baar">  
                                                    <p>{data.icon_lable}</p>
                                                </div>
                                            </button>
                                            <div className="list-button-side-baar" ref={(el) => (dropdownRefs.current[index] = el)}>
                                                <button onClick={() => toggleDropdown(index)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                                        <path fillRule="evenodd" d="M3.864 8.333a1.363 1.363 0 1 1 0 2.726 1.363 1.363 0 0 1 0-2.726Zm6.136 0a1.363 1.363 0 1 1 .001 2.726A1.363 1.363 0 0 1 10 8.333Zm6.136 0a1.363 1.363 0 1 1 .001 2.726 1.363 1.363 0 0 1 0-2.726Z"></path>
                                                    </svg>
                                                </button>
                                            </div>
                                            {openDropdown === index && (
                                                <div className="inner-dropdown-menu">
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleEditSingle(data)}>Edit</button>
                                                    </div>
                                                    <div className="button-list">
                                                        <button type="button" onClick={() => handleDeleteSingle(data)}> Delete</button>
                                                    </div>
                                                </div>
                                            )}
                                        </li>
                                    ))}
                                </ul>
                            ) : (
                                <></>
                            )}
                        </div>
                        <div className="add-side-baar-button">
                            <button onClick={() => setActiveSettingElementsTab("all_icon_list")}>+ Add Icon</button>
                        </div>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "all_icon_list" && (
                <div className="inner-box-layout">
                    <span>
                        <button
                        className="button-color"
                        type="button"
                        onClick={() => setActiveSettingElementsTab("main")}
                        >
                        <i className="fa fa-angle-left" aria-hidden="true"></i> Cancel
                        </button>
                        Choose Icon
                    </span>

                    <div className="side-baar-box-header">
                        <div className="box-header-row">
                        {isLoading ? (
                            <div className="inner-loader-container">
                                <div className="inner-spinner"></div>
                                <p>Loading, please wait...</p>
                            </div>
                        ) : apiSociaMediaIcons?.length > 0 ? (
                            <ul className="side-baar_texticon-list">
                                {apiSociaMediaIcons.map((icon) => (
                                   <li
                                        key={icon.id}
                                        title={icon.icon_lable}
                                        onClick={() => handleSubmitSingle(icon.id)}
                                        className="clickable-icon-li"
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div
                                            className="social-icon-list"
                                            dangerouslySetInnerHTML={{ __html: icon.svg_icon }}
                                        ></div>
                                        <span>{icon.icon_lable}</span>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p>No icons available. Please try again.</p>
                        )}
                        </div>
                    </div>
                </div>
            )}

            {activeSettingElementsTab === "edit_single" && (
                <div className="inner-box-layout">
                    {isLoading ? (
                        <div className="inner-loader-container">
                            <div className="inner-spinner"></div>
                            <p>Loading, please wait...</p>
                        </div>
                    ) : apiSingle ? (
                        <>
                        <form onSubmit={handleUpdateSingle}>
                            <span>
                                <button className="button-color" type="button" onClick={() => setActiveSettingElementsTab("main")}>
                                    <i className="fa fa-angle-left" aria-hidden="true"></i>Cancel
                                </button>
                                Edit Icon
                               
                            </span>

                            <div className="side-baar-box-header">
                                <div className="box-header-row bubble-text">
                                    <label>Add url to a social profile</label>
                                    <input name="icon_url" value={apiSingle.icon_url || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, icon_url: e.target.value })} placeholder="Icon Url..." type="text" />
                                </div>
                                <div className="box-header-row bubble-text">
                                    <label>Label</label>
                                    <input name="icon_lable" value={apiSingle.icon_lable || ""}
                                        onChange={(e) => setApiSingle({ ...apiSingle, icon_lable: e.target.value })} placeholder="Icon Lable..." type="text" />
                                </div>
                                 <div className="customize-button mb-2"> 
                                    <button type="submit" className="float-none text-black bg-white" disabled={isSubmitSingle}>
                                        {isSubmitSingle ? "Updating..." : "Update"}
                                    </button>
                                 </div>
                                
                            </div>
                        </form>
                        </>
                    ) : (
                        <p>No single details. Please try again.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default IconsTab;